import { GET, DOWNLOADFILE } from "../../API/get";

export const fetchInvoices = async (current_page, serach_text, sort_key, sort_direction) => {
    let url = `job/invoices/INSTAFIX_TO_FTM_PAYMENT_INVOICE/${current_page}?search=${serach_text.trim()}&sort_key=${sort_key}&sort_direction=${sort_direction}`;
    
    const response = await GET(url);
    return response.status === "Success" ? response : null;
}

export const downloadInvoice = async (job_id) => {
    await DOWNLOADFILE(`job/invoices/download/${job_id}/INSTAFIX_TO_FTM_PAYMENT_INVOICE`);
}